import { OfferOrder } from 'src/models';

import * as Styles from '../CancelTransferButton/CancelTransferButton.styles';
import { MButton } from '../MButton/MButton';

interface CancelOfferOrderButtonProps {
  value: OfferOrder;
  onClick: (offerOrder: OfferOrder) => void;
}

export const CancelOfferOrderButton = ({ value, onClick }: CancelOfferOrderButtonProps) => {
  if (value.status.isPendingFunds || value.status.isPendingOfferClose || value.status.isPendingAction) {
    return (
      <MButton type='tertiary' danger className={Styles.cancelButton} onClick={() => onClick(value)}>
        Cancel
      </MButton>
    );
  }

  return null;
};
